/* eslint-disable no-restricted-imports */
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { useDataTreeUsingState } from '@juvare/common-data-table-ui/DataTree';
import { FiltersBar, useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { LayoutRows2 } from '@juvare/common-web-ui/LayoutRows2';
import { getRolesHavingPermissions } from '@juvare/contact-management/backend/features/permissions/shared/permissions';
import { useAccountsTable } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountsTable';
import { OrganizationTreeWithDetails } from '@juvare/contact-management/ui/features/organizations';
import { useOrganizationSelectionTree } from '@juvare/contact-management/ui/features/organizations/hooks/useOrganizationSelectionTree';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, Button, IconButton, Tab, Tabs, Toolbar, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useDocumentLibraryTranslations } from '../../../hooks';
import { useSystemRoleTable } from '../../../hooks/useSystemRoleTable';
import { TabPanel } from './TabPanel';
const TabsMap = {
    accounts: 0,
    organizations: 1,
    systemRoles: 2,
};
export const PermissionsSelection = ({ ownerId, handleSave, handleClose, canAccessAccounts }) => {
    const { t } = useDocumentLibraryTranslations();
    const [tabIndex, setTabIndex] = useState(canAccessAccounts ? TabsMap.accounts : TabsMap.organizations);
    const { orgRoleMap, systemRoleMap } = useSelector(getSettings);
    const orgRoles = getRolesHavingPermissions(orgRoleMap, ['view-documents', 'manage-documents']);
    const systemRoles = getRolesHavingPermissions(systemRoleMap, ['manage-documents']);
    const accountStorageFilter = [
        {
            op: 'or',
            filter: [
                {
                    column: 'orgRoleSet',
                    op: 'overlap',
                    value: orgRoles,
                },
                {
                    column: 'systemRole',
                    op: 'in',
                    value: systemRoles,
                },
            ],
        },
        {
            op: '!=',
            id: ownerId,
        },
        { column: 'systemStatus', op: '=', value: 'active' },
    ];
    const { dataTableProps: accountDataTableProps } = useAccountsTable({
        rowSelectionEnabled: true,
        staticStorageClientFilter: accountStorageFilter,
    });
    const organizationsTree = useOrganizationSelectionTree({
        useDataTreeFunction: useDataTreeUsingState,
        staticFilters: {
            orgPermissions: ['view-and-message-members', 'manage-members'],
        },
    });
    const organizationTreeFilterConfig = useFilterConfig((builder) => {
        builder.quickSearchFilter({
            sx: { maxWidth: { xs: undefined, sm: 340 } },
            label: t('common.search'),
            dataPath: 'search',
            dataTest: 'search-filter',
        });
    }, [t]);
    const { dataTableProps: systemRoleDataTableProps } = useSystemRoleTable();
    return (React.createElement(LayoutRows2, { row1: React.createElement(React.Fragment, null,
            React.createElement(AppBar, { style: { position: 'static' } },
                React.createElement(Toolbar, null,
                    React.createElement(IconButton, { edge: 'start', color: 'inherit', onClick: handleClose, "aria-label": t('common.close') },
                        React.createElement(CloseIcon, null)),
                    React.createElement(Typography, { variant: 'h6', style: { flexGrow: 1 } }, t('documents.permissionSelection')),
                    React.createElement(Button, { "data-test": 'save-button', color: 'inherit', onClick: () => {
                            var _a, _b, _c;
                            return handleSave((_a = accountDataTableProps.selectedRowIds) !== null && _a !== void 0 ? _a : [], (_b = organizationsTree.selectedOrganizationIds) !== null && _b !== void 0 ? _b : [], (_c = systemRoleDataTableProps.selectedRowIds) !== null && _c !== void 0 ? _c : []);
                        } }, t('common.add')))),
            React.createElement(Tabs, { value: tabIndex, onChange: (e, newValue) => setTabIndex(newValue) },
                canAccessAccounts && React.createElement(Tab, { label: t('documents.accounts'), "data-test": 'accounts-tab', value: TabsMap.accounts }),
                React.createElement(Tab, { label: t('documents.organizations'), "data-test": 'organizations-tab', value: TabsMap.organizations }),
                React.createElement(Tab, { label: t('documents.systemRole'), "data-test": 'system-roles-tab', value: TabsMap.systemRoles }))), row2: React.createElement(React.Fragment, null,
            canAccessAccounts && (React.createElement(TabPanel, { value: tabIndex, index: TabsMap.accounts },
                React.createElement(Box, { sx: { p: 2 } },
                    React.createElement(DataTable, Object.assign({}, accountDataTableProps, { globalActions: undefined, localActions: undefined }))))),
            React.createElement(TabPanel, { value: tabIndex, index: TabsMap.organizations },
                React.createElement(OrganizationTreeWithDetails, { dataTreeProps: organizationsTree.dataTreeProps, filtersBar: React.createElement(FiltersBar, Object.assign({}, organizationsTree.filtersBarProps, { config: organizationTreeFilterConfig })), activeOrganizationId: organizationsTree.activeOrganizationId, multiSelect: true, "data-test": 'organization-tree' })),
            React.createElement(TabPanel, { value: tabIndex, index: TabsMap.systemRoles },
                React.createElement(Box, { sx: { p: 2 } },
                    React.createElement(DataTable, Object.assign({}, systemRoleDataTableProps, { globalActions: undefined, localActions: undefined }))))), fullHeightRow: 'row2', "data-test": 'permission-selection-page', row2Scrollable: true }));
};
